import { render, staticRenderFns } from "./Project3.vue?vue&type=template&id=1944ed46&scoped=true&"
import script from "./Project3.vue?vue&type=script&lang=js&"
export * from "./Project3.vue?vue&type=script&lang=js&"
import style0 from "./Project3.vue?vue&type=style&index=0&id=1944ed46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944ed46",
  null
  
)

export default component.exports